import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import "../Tenancy/tenancy.css"
import { getTrades, saveTrade, deleteTrade, toggleTrade, setTradeRate } from "../../services/admin"

const empty = { code: "", name: "", description: "", salary_type: "variable", default_hourly_rate: "", default_basic_salary: "", is_active: true }
const emptyRate = { scope: "global", scope_id: "", hourly_rate: "", basic_salary: "", effective_from: "" }

const Trades = ({ embedded }) => {
  document.title = "Trades | Everrise"
  const [rows, setRows] = useState([])
  const [reload, setReload] = useState(0)
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(empty)
  const [rateModal, setRateModal] = useState(false)
  const [rate, setRate] = useState(emptyRate)
  const [rateTrade, setRateTrade] = useState(null)

  useEffect(() => {
    ;(async () => { try { const r = await getTrades(); setRows(r?.data || []) } catch (e) { toastError(e?.message) } })()
  }, [reload])

  const open = item => { setForm(item ? { ...empty, ...item, default_hourly_rate: item.default_hourly_rate ?? "" } : empty); setModal(true) }
  const save = async () => {
    try {
      const payload = { ...form, default_hourly_rate: form.default_hourly_rate === "" ? null : form.default_hourly_rate }
      await saveTrade(form.id, payload); toastSuccess("Saved"); setModal(false); setReload(reload + 1)
    } catch (e) { toastError(e?.message || (e?.errors && Object.values(e.errors)[0][0]) || "Save failed") }
  }
  const remove = async id => { if (!window.confirm("Delete trade?")) return; try { await deleteTrade(id); toastSuccess("Deleted"); setReload(reload + 1) } catch (e) { toastError(e?.message) } }
  const toggle = async id => { try { await toggleTrade(id); setReload(reload + 1) } catch (e) { toastError(e?.message) } }

  const openRate = t => { setRateTrade(t); setRate(emptyRate); setRateModal(true) }
  const saveRate = async () => {
    try {
      await setTradeRate(rateTrade.id, { scope: rate.scope, scope_id: rate.scope_id || null, hourly_rate: rate.hourly_rate || null, basic_salary: rate.basic_salary || null, effective_from: rate.effective_from || null })
      toastSuccess("Rate set"); setRateModal(false); setReload(reload + 1)
    } catch (e) { toastError(e?.message || "Failed") }
  }
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  return (
    <div className={embedded ? "" : "page-content tnt-scope"}>
      <div className={embedded ? "" : "container-fluid"}>
        {embedded ? (
          <div className="d-flex justify-content-end mb-2 app-tab-add">
            <Button color="primary" size="sm" onClick={() => open(null)}>+ Trade</Button>
          </div>
        ) : (
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumbs title="Administration" breadcrumbObject={[{ title: "Administration", link: "#" }, { title: "Trades", link: "#" }]} />
            <Button color="primary" size="sm" onClick={() => open(null)}>+ Trade</Button>
          </div>
        )}
        <Card className="me-2 px-2 pb-2 main-dashboard-bg"><CardBody>
        <Table responsive borderless className="align-middle tnt-table">
          <thead><tr><th>Code</th><th>Name</th><th>Type</th><th>Default rate</th><th>Resolved rate</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.code}</td><td>{r.name}</td><td>{r.salary_type}</td>
                <td>{r.salary_type === "variable" ? r.default_hourly_rate : "per worker"}</td>
                <td>{r.resolved_hourly_rate ?? "—"}</td>
                <td>{r.is_active ? <span className="badge bg-success">Active</span> : <span className="badge bg-secondary">Inactive</span>}</td>
                <td className="text-nowrap">
                  {r.salary_type === "variable" && <i className="uil-usd-circle action-icon" role="button" title="Set rate" onClick={() => openRate(r)} />}
                  <i className="uil-pen action-icon" role="button" title="Edit" onClick={() => open(r)} />
                  <i className={`${r.is_active ? "uil-ban" : "uil-check-circle"} action-icon`} role="button" title={r.is_active ? "Deactivate" : "Activate"} onClick={() => toggle(r.id)} />
                  <i className="uil-trash-alt action-icon danger" role="button" title="Delete" onClick={() => remove(r.id)} />
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan="7" className="text-center text-muted">No trades</td></tr>}
          </tbody>
        </Table>
      </CardBody></Card>
      </div>

      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>{form.id ? "Edit" : "New"} Trade</ModalHeader>
        <ModalBody><Row>
          <Col md={6}><FormGroup><Label>Code</Label><Input value={form.code} disabled={!!form.id} placeholder="auto" onChange={e => set("code", e.target.value)} /></FormGroup></Col>
          <Col md={6}><FormGroup><Label>Name *</Label><Input value={form.name} onChange={e => set("name", e.target.value)} /></FormGroup></Col>
          <Col md={6}><FormGroup><Label>Salary type</Label><Input type="select" value={form.salary_type} onChange={e => set("salary_type", e.target.value)}><option value="variable">variable</option><option value="fixed">fixed</option></Input></FormGroup></Col>
          {form.salary_type === "variable" && <Col md={6}><FormGroup><Label>Default hourly rate *</Label><Input value={form.default_hourly_rate} onChange={e => set("default_hourly_rate", e.target.value)} /></FormGroup></Col>}
          <Col md={12}><FormGroup><Label>Description</Label><Input type="textarea" value={form.description || ""} onChange={e => set("description", e.target.value)} /></FormGroup></Col>
        </Row></ModalBody>
        <ModalFooter><Button color="light" onClick={() => setModal(false)}>Cancel</Button><Button color="primary" onClick={save}>Save</Button></ModalFooter>
      </Modal>

      <Modal isOpen={rateModal} toggle={() => setRateModal(false)}>
        <ModalHeader toggle={() => setRateModal(false)}>Set rate — {rateTrade?.name}</ModalHeader>
        <ModalBody>
          <FormGroup><Label>Scope</Label><Input type="select" value={rate.scope} onChange={e => setRate({ ...rate, scope: e.target.value })}><option value="global">Global</option><option value="group">Group</option><option value="company">Company</option></Input></FormGroup>
          {rate.scope !== "global" && <FormGroup><Label>{rate.scope === "group" ? "Group" : "Company"} ID</Label><Input value={rate.scope_id} onChange={e => setRate({ ...rate, scope_id: e.target.value })} /></FormGroup>}
          <FormGroup><Label>Hourly rate</Label><Input value={rate.hourly_rate} onChange={e => setRate({ ...rate, hourly_rate: e.target.value })} /></FormGroup>
          <FormGroup><Label>Effective from</Label><Input type="date" value={rate.effective_from} onChange={e => setRate({ ...rate, effective_from: e.target.value })} /></FormGroup>
        </ModalBody>
        <ModalFooter><Button color="light" onClick={() => setRateModal(false)}>Cancel</Button><Button color="primary" onClick={saveRate}>Set</Button></ModalFooter>
      </Modal>
    </div>
  )
}

export default Trades
